import get from 'lodash/get';
import { COUNT_TABLE_RECORDS } from 'constants/constants';
import { useQuery } from '@apollo/client/react';
import { ContactMessagesDocument, type ContactMessagesQuery } from 'graphql/generated/graphql';

/** The messages of a page (the schema allows a null list and null items). */
export type TContactMessages = NonNullable<ContactMessagesQuery['contactMessages']>['messages'];

const useGetMessages = ({ currentPage, filter }: { currentPage: number; filter: string }) => {
  const { loading, data } = useQuery(ContactMessagesDocument, {
    variables: {
      filter,
      offset: COUNT_TABLE_RECORDS * (currentPage - 1),
      limit: COUNT_TABLE_RECORDS,
    },
  });

  const noMessages: TContactMessages = [];
  const messages = get(data, 'contactMessages.messages', noMessages);
  const total = get(data, 'contactMessages.count', 0);

  return { messages, total, loading };
};

export default useGetMessages;
